import React from 'react';
import { StyledTable } from './styled';
import { TableProps } from 'antd/lib/table/Table';

const Table = ({ ...props }: TableProps<any>) => {
  return <StyledTable {...props} />;
};

export default Table;
